import { Checkbox, CheckboxProps } from 'antd';
import React from 'react';

import './styles.less';

type Props = Pick<
  CheckboxProps,
  'checked' | 'children' | 'className' | 'disabled' | 'onChange' | 'value'
>;

/**
 * A wrapper around the antd Button with our custom styling applied.
 */
function DefaultCheckbox({
  checked,
  children,
  className,
  disabled,
  onChange,
  value
}: Props): JSX.Element {
  return (
    <div className="DefaultCheckbox">
      <Checkbox
        checked={checked}
        className={className}
        disabled={disabled}
        onChange={onChange}
        value={value}
      >
        {children}
      </Checkbox>
    </div>
  );
}

export default DefaultCheckbox;
